import withGoogleAds from "shared/hooks/withGoogleAds";
import { GTM_CLIENTS, TEMPLATE_TYPES } from "utils/constants";
import B2C_AMELLIS from "./Amellis";
import DEFAULT from "./Default";
import B2C_LMF from "./LMF";
import MILTIS from "./Miltis";
import MILTIS_TER from "./MiltisTer";
import B2C_MUTUAL_MOBILITY from "./MutualMobility";
import RADIANCE from "./Radiance";
import RADIANCE_AURA_TER from "./RadianceAuraTer";
import RADIANCE_COSA from "./RadianceCosa";
import SOLYON from "./Solyon";

const wrapWithGoogleAds = (templatesMap) =>
  Object.keys(templatesMap).reduce((acc, key) => {
    const Component = templatesMap[key];

    // Only wrap actual React components (functions), keep other entries as-is
    if (typeof Component === "function") {
      acc[key] = withGoogleAds(Component, {
        gtmId: GTM_CLIENTS.SOLYON.GTM_ID,
        gtmContainerId: GTM_CLIENTS.SOLYON.GTM_CONTAINER_ID,
      });
    } else {
      acc[key] = Component;
    }

    return acc;
  }, {});

const Templates = {
  [TEMPLATE_TYPES.DEFAULT]: DEFAULT,
  [TEMPLATE_TYPES.RADIANCE]: RADIANCE,
  [TEMPLATE_TYPES.RADIANCE_COSA]: RADIANCE_COSA,
  [TEMPLATE_TYPES.RADIANCE_AURA_TER]: RADIANCE_AURA_TER,
  [TEMPLATE_TYPES.B2C_SOLYON]: wrapWithGoogleAds(SOLYON),
  [TEMPLATE_TYPES.B2C_LMF]: B2C_LMF,
  [TEMPLATE_TYPES.B2C_AMELLIS]: B2C_AMELLIS,
  [TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]: B2C_MUTUAL_MOBILITY,
  [TEMPLATE_TYPES.B2C_MILTIS]: MILTIS,
  [TEMPLATE_TYPES.B2C_MILTIS_TER]: MILTIS_TER,
};
export default Templates;
